export const SIDEBAR_KEY_BACKOFFICE = "BACKOFFICE";

// NURSERY
export const SIDEBAR_KEY_NURSERY = "NURSERY";
// NURSERY CHILDREN
export const SIDEBAR_KEY_NURSERY_LIST = "NURSERY_LIST";
export const SIDEBAR_KEY_PROMOTION_LIST = "PROMOTION_LIST";
export const SIDEBAR_KEY_LOG_LIST = "LOG_LIST";
